import type { AxiosResponse } from 'axios';

const CLEANUP_TIMEOUT = process.env.NODE_ENV === 'test' ? 0 : 100;

export const downloadFile = (response: AxiosResponse<Blob>, defaultFileName: string): void => {
    let fileName = defaultFileName;

    const contentDisposition = response.headers['content-disposition'] || response.headers['Content-Disposition'];

    if (contentDisposition) {
        const fileNameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        const matches = fileNameRegex.exec(contentDisposition);
        if (matches?.[1]) {
            fileName = matches[1].replace(/['"]/g, '');
        }
    }

    if (!fileName) {
        const timestamp = new Date().toISOString().split('T')[0];
        const extension = response.headers['content-type'] === 'application/vnd.ms-excel' ? 'xlsx' : 'csv';

        fileName = `MAN_ChargeGo_Charging_Activity_${timestamp}.${extension}`;
    }

    const blob = new Blob([response.data], {
        type: String(response.headers['content-type'] ?? 'application/octet-stream'),
    });

    const fileURL = window.URL.createObjectURL(blob);
    const tempLink = document.createElement('a');
    tempLink.href = fileURL;
    tempLink.setAttribute('download', fileName);
    tempLink.style.display = 'none';
    document.body.appendChild(tempLink);
    tempLink.click();

    document.body.removeChild(tempLink);
    window.URL.revokeObjectURL(fileURL);
};
